import { useTheme } from '@emotion/react';
import { Picture } from '../picture/picture';
import { Link } from '../styled/Link';
import { Material } from '../../models';
import { BLOG_DOMAIN } from '../../lib/api/apiUrl';
import FavoriteButtonCardWrapper from '../favorite/FavoriteButtonCardWrapper';
import FavoriteButton from '../favorite/FavoriteButton';
import { FavoriteKinds } from '../../models/favorite';

export function MaterialCard({
  item,
  fromFavorite = false,
}: {
  item: Material;
  fromFavorite?: boolean;
}) {
  const theme = useTheme();

  function getUrl(materialItem: Material) {
    // temporarily until the backend is fixed (task 496)
    if (!materialItem.blog_categories) {
      return new URL(`${BLOG_DOMAIN}/blog/`).href;
    }
    return new URL(
      `${BLOG_DOMAIN}/blog/${materialItem.blog_categories[0].slug}/${materialItem.slug}`
    ).href;
  }
  return (
    <div
      // action-card
      css={{
        height: '100%',
        borderRadius: '4px',
        backgroundColor: '#fff',
        position: 'relative',
        top: 0,
        width: '100%',
        transition: 'all 0.3s ease',
        display: 'flex',
        flexDirection: 'column',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: theme.constants.boxShadow,
        },
      }}
    >
      <Link
        // action-card__image-wrapper
        href={getUrl(item)}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        css={{
          height: 0,
          width: '100%',
          paddingBottom: '75%',
          position: 'relative',
          display: 'block',
          '&:hover': {
            color: theme.colors.black,
          },
        }}
      >
        <div
          // action-card__image
          css={{
            borderRadius: '4px',
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            overflow: 'hidden',
          }}
        >
          <Picture
            src={item.animated_cover || item.jpg_card || item.webp_card}
            alt={item.title}
          />
        </div>
      </Link>
      {fromFavorite && (
        <FavoriteButtonCardWrapper>
          <FavoriteButton
            kind={FavoriteKinds.material}
            id={item.id}
            size='small'
            variant='red-outline'
          />
        </FavoriteButtonCardWrapper>
      )}
      <div
        // action-card__info
        css={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'space-between',
          padding: '14px 14px 24px',
        }}
      >
        <Link
          // person-card__title
          href={getUrl(item)}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          css={{
            fontFamily: 'Montserrat',
            fontSize: 18,
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '22px',
            letterSpacing: '0em',
            color: theme.colors.text,
            marginBottom: 10,
          }}
        >
          {item.title}
        </Link>
        {item.views && (
          <div
            // action-card__misc
            css={{
              position: 'absolute',
              bottom: 12,
              right: 20,
              left: 20,
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              color: theme.colors.grayStrong,
              fontSize: 12,
              fontWeight: 500,
            }}
          >
            <div
              // action-card__misc-item
              css={{
                display: 'flex',
                alignItems: 'center',
                marginRight: 18,
                height: 16,
                fontFamily: 'Golos',
                fontSize: 12,
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: '16px',
                letterSpacing: '0.01em',

                svg: {
                  flex: '0 0 auto',
                  marginRight: 5,
                },
              }}
            >
              <svg
                css={{
                  width: 16,
                  height: 16,
                  fill: theme.colors.grayStrong,
                }}
              >
                <use xlinkHref='#views2' />
              </svg>
              <span>{item.views}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
